import { references } from './references.js'
import { community } from './community.js'

const data: any = { references, community }

export default data
